// Pure, dependency-free helpers for the irrigation pressure-alert badge.
// Shared by web (NextActionsContainer) and mobile (NextActions) — keep
// platform-agnostic.
//
// The API stamps `pressure_alert` on an irrigation event when the reading fell
// outside the pressure sensor's configured boundaries — the same condition that
// raises Notification Center cases 26/27 in sciroot-backend. Both clients badge
// the Reported Events row from it, so the level -> translation-key mapping lives
// here rather than being written out twice and left to drift apart.

const PRESSURE_ALERT_LOW = 'low';
const PRESSURE_ALERT_HIGH = 'high';

const PRESSURE_ALERT_HINT_KEYS = {
  [PRESSURE_ALERT_LOW]: 'low_pressure_event_hint',
  [PRESSURE_ALERT_HIGH]: 'high_pressure_event_hint',
};

// Normalizes the raw flag to 'low' / 'high', or null when it is missing or
// unrecognized. Anything unknown yields null so a level added on the API side
// can never render as a badge with no tooltip text.
const pressureAlertLevel = value =>
  value === PRESSURE_ALERT_LOW || value === PRESSURE_ALERT_HIGH ? value : null;

// Translation key for the badge tooltip; null when there is no alert.
const pressureAlertHintKey = value => {
  const level = pressureAlertLevel(value);
  return level ? PRESSURE_ALERT_HINT_KEYS[level] : null;
};

module.exports = {
  PRESSURE_ALERT_LOW,
  PRESSURE_ALERT_HIGH,
  pressureAlertLevel,
  pressureAlertHintKey,
};
